// extracted by mini-css-extract-plugin
module.exports = {"container":"ShipmentTracking_container__1A64l"};